<template>
  <div
    id="background"
    v-bind:style="{ backgroundColor: bodyBackgroundColor.guestbookBodyColor }"
  >
    <language-bar v-if="!$isSingleLanguage"></language-bar>
    <fetching-loader
      displayType="displayBlock"
      v-if="!guestbookFetched"
    ></fetching-loader>
    <GuestbookNavigation
      v-if="showNavigation"
      v-bind:links="returnedData.links"
      v-bind:nav="returnedData.nav"
      v-bind:pagesOverview="pagesOverview"
      v-bind:languageTypesIndex="languageTypesIndex"
    />
    <guestbook-header
      v-if="showHeader"
      v-bind:headerContent="returnedData.headerContent"
      v-bind:languageTypesIndex="languageTypesIndex"
    ></guestbook-header>
    <guestbook-boxes
      v-if="showBoxes"
      v-bind:boxes="createArray(returnedData.boxes)"
      v-bind:pagesOverview="pagesOverview"
      v-bind:customFonts="customFonts"
      v-bind:languageTypesIndex="languageTypesIndex"
    ></guestbook-boxes>
    <button-global
      text="ADD FOOTER"
      size="large"
      type="neutral"
      style="display: flex; justify-content: center; margin: 25px 0"
      @eventPassed="addFooter"
      v-if="!showFooter"
    ></button-global>
    <guestbook-footer
      v-bind:imageFooter="returnedData.imageFooter"
      v-else
    ></guestbook-footer>

    <div class="outerPreviewWrap add--text-align-center">
      <div
        class="preview-menu__header"
        :style="{ color: changePreviewColorText }"
      >
        PREVIEW
      </div>
      <div
        class="preview-menu__toogle"
        :style="{ color: changePreviewColorText }"
        @mouseover="hover = true"
        @mouseleave="hover = false"
        v-on:click="toogleClicked"
      >
        <v-icon class="item-icon" name="laptop" scale="2.5"></v-icon>
        <img
          class="item-toogle flip"
          src="@/assets/EndOfLife/toggleDisabled.svg"
          alt="enabled"
          v-if="toogleActive"
        />
        <img
          class="item-toogle"
          src="@/assets/EndOfLife/toggleDisabled.svg"
          alt="disabled"
          v-else
        />
        <v-icon class="item-icon phone" name="mobile-alt" scale="2.5"></v-icon>
      </div>
      <div class="tooltip" v-if="hover && this.browserCheck() == 'Safari'">
        Phone preview is not available on Safari
      </div>
      <div class="GhostWrap preview-menu" @click="openPreview('anonymous')">
        <svg
          class="preview-menu__icon-anonymous"
          width="20"
          height="37"
          viewBox="0 0 20 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="toogleActive"
        >
          <path
            d="M3.64508 0H16.3549C18.3693 0 20 1.6307 20 3.64508V33.1894C20 35.2038 18.3693 36.8345 16.3549 36.8345H3.64508C1.6307 36.8345 0 35.2038 0 33.1894V3.64508C0 1.6307 1.6307 0 3.64508 0ZM2.35012 29.5923H17.6499V6.90648H2.35012V29.5923ZM9.97602 34.6283C11.1271 34.6283 11.9904 33.765 11.9904 32.6619C11.9904 31.5108 11.1271 30.6475 9.97602 30.6475C8.8729 30.6475 8.00959 31.5108 8.00959 32.6619C8.00959 33.765 8.8729 34.6283 9.97602 34.6283Z"
            fill="white"
          />
          <path
            d="M14.0714 20.1429H12.3571C12.2388 20.1429 12.1429 20.2388 12.1429 20.3571V22.0714C12.1429 22.1898 12.2388 22.2857 12.3571 22.2857H14.0714C14.1898 22.2857 14.2857 22.1898 14.2857 22.0714V20.3571C14.2857 20.2388 14.1898 20.1429 14.0714 20.1429Z"
            fill="white"
          />
          <path
            d="M11.9286 18.4286H10.6429C10.5245 18.4286 10.4286 18.5245 10.4286 18.6429V19.9286C10.4286 20.0469 10.5245 20.1429 10.6429 20.1429H11.9286C12.0469 20.1429 12.1429 20.0469 12.1429 19.9286V18.6429C12.1429 18.5245 12.0469 18.4286 11.9286 18.4286Z"
            fill="white"
          />
          <path
            d="M15.7857 22.2857H14.5C14.3817 22.2857 14.2857 22.3817 14.2857 22.5V23.7857C14.2857 23.9041 14.3817 24 14.5 24H15.7857C15.9041 24 16 23.9041 16 23.7857V22.5C16 22.3817 15.9041 22.2857 15.7857 22.2857Z"
            fill="white"
          />
          <path
            d="M15.7857 18.4286H14.9286C14.8102 18.4286 14.7143 18.5245 14.7143 18.6429V19.5C14.7143 19.6183 14.8102 19.7143 14.9286 19.7143H15.7857C15.9041 19.7143 16 19.6183 16 19.5V18.6429C16 18.5245 15.9041 18.4286 15.7857 18.4286Z"
            fill="white"
          />
          <path
            d="M11.5 22.7143H10.6429C10.5245 22.7143 10.4286 22.8102 10.4286 22.9286V23.7857C10.4286 23.9041 10.5245 24 10.6429 24H11.5C11.6183 24 11.7143 23.9041 11.7143 23.7857V22.9286C11.7143 22.8102 11.6183 22.7143 11.5 22.7143Z"
            fill="white"
          />
          <path
            d="M15.1429 12H11.2857C11.0584 12 10.8404 12.0903 10.6796 12.2511C10.5189 12.4118 10.4286 12.6298 10.4286 12.8571V16.7143C10.4286 16.9416 10.5189 17.1596 10.6796 17.3204C10.8404 17.4811 11.0584 17.5714 11.2857 17.5714H15.1429C15.3702 17.5714 15.5882 17.4811 15.7489 17.3204C15.9097 17.1596 16 16.9416 16 16.7143V12.8571C16 12.6298 15.9097 12.4118 15.7489 12.2511C15.5882 12.0903 15.3702 12 15.1429 12ZM14.2857 15.6429C14.2857 15.6997 14.2631 15.7542 14.223 15.7944C14.1828 15.8346 14.1283 15.8571 14.0714 15.8571H12.3571C12.3003 15.8571 12.2458 15.8346 12.2056 15.7944C12.1654 15.7542 12.1429 15.6997 12.1429 15.6429V13.9286C12.1429 13.8717 12.1654 13.8172 12.2056 13.777C12.2458 13.7369 12.3003 13.7143 12.3571 13.7143H14.0714C14.1283 13.7143 14.1828 13.7369 14.223 13.777C14.2631 13.8172 14.2857 13.8717 14.2857 13.9286V15.6429Z"
            fill="white"
          />
          <path
            d="M8.71429 12H4.85714C4.62981 12 4.4118 12.0903 4.25105 12.2511C4.09031 12.4118 4 12.6298 4 12.8571V16.7143C4 16.9416 4.09031 17.1596 4.25105 17.3204C4.4118 17.4811 4.62981 17.5714 4.85714 17.5714H8.71429C8.94161 17.5714 9.15963 17.4811 9.32038 17.3204C9.48112 17.1596 9.57143 16.9416 9.57143 16.7143V12.8571C9.57143 12.6298 9.48112 12.4118 9.32038 12.2511C9.15963 12.0903 8.94161 12 8.71429 12ZM7.85714 15.6429C7.85714 15.6997 7.83457 15.7542 7.79438 15.7944C7.75419 15.8346 7.69969 15.8571 7.64286 15.8571H5.92857C5.87174 15.8571 5.81723 15.8346 5.77705 15.7944C5.73686 15.7542 5.71429 15.6997 5.71429 15.6429V13.9286C5.71429 13.8717 5.73686 13.8172 5.77705 13.777C5.81723 13.7369 5.87174 13.7143 5.92857 13.7143H7.64286C7.69969 13.7143 7.75419 13.7369 7.79438 13.777C7.83457 13.8172 7.85714 13.8717 7.85714 13.9286V15.6429Z"
            fill="white"
          />
          <path
            d="M8.71429 18.4286H4.85714C4.62981 18.4286 4.4118 18.5189 4.25105 18.6796C4.09031 18.8404 4 19.0584 4 19.2857V23.1429C4 23.3702 4.09031 23.5882 4.25105 23.7489C4.4118 23.9097 4.62981 24 4.85714 24H8.71429C8.94161 24 9.15963 23.9097 9.32038 23.7489C9.48112 23.5882 9.57143 23.3702 9.57143 23.1429V19.2857C9.57143 19.0584 9.48112 18.8404 9.32038 18.6796C9.15963 18.5189 8.94161 18.4286 8.71429 18.4286ZM7.85714 22.0714C7.85714 22.1283 7.83457 22.1828 7.79438 22.223C7.75419 22.2631 7.69969 22.2857 7.64286 22.2857H5.92857C5.87174 22.2857 5.81723 22.2631 5.77705 22.223C5.73686 22.1828 5.71429 22.1283 5.71429 22.0714V20.3571C5.71429 20.3003 5.73686 20.2458 5.77705 20.2056C5.81723 20.1654 5.87174 20.1429 5.92857 20.1429H7.64286C7.69969 20.1429 7.75419 20.1654 7.79438 20.2056C7.83457 20.2458 7.85714 20.3003 7.85714 20.3571V22.0714Z"
            fill="white"
          />
        </svg>
        <svg
          class="preview-menu__icon-anonymous_desktop"
          width="40"
          height="32"
          viewBox="0 0 32 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-else
        >
          <path
            d="M6.93333 17.0667C6.2 17.0667 5.57222 16.8056 5.05 16.2833C4.52778 15.7611 4.26667 15.1333 4.26667 14.4V2.66667C4.26667 1.93333 4.52778 1.30556 5.05 0.783333C5.57222 0.261111 6.2 0 6.93333 0H25.0667C25.8 0 26.4278 0.261111 26.95 0.783333C27.4722 1.30556 27.7333 1.93333 27.7333 2.66667V14.4C27.7333 15.1333 27.4722 15.7611 26.95 16.2833C26.4278 16.8056 25.8 17.0667 25.0667 17.0667H6.93333ZM6.4 2.66667V14.4C6.4 14.5444 6.45278 14.6694 6.55833 14.775C6.66389 14.8806 6.78889 14.9333 6.93333 14.9333H25.0667C25.2111 14.9333 25.3361 14.8806 25.4417 14.775C25.5472 14.6694 25.6 14.5444 25.6 14.4V2.66667C25.6 2.52222 25.5472 2.39722 25.4417 2.29167C25.3361 2.18611 25.2111 2.13333 25.0667 2.13333H6.93333C6.78889 2.13333 6.66389 2.18611 6.55833 2.29167C6.45278 2.39722 6.4 2.52222 6.4 2.66667ZM29.3333 18.1333H32V19.7333C32 20.1778 31.7389 20.5556 31.2167 20.8667C30.6944 21.1778 30.0667 21.3333 29.3333 21.3333H2.66667C1.93333 21.3333 1.30556 21.1778 0.783333 20.8667C0.261111 20.5556 0 20.1778 0 19.7333V18.1333H29.3333ZM17.3333 19.7333C17.5111 19.7333 17.6 19.6444 17.6 19.4667C17.6 19.2889 17.5111 19.2 17.3333 19.2H14.6667C14.4889 19.2 14.4 19.2889 14.4 19.4667C14.4 19.6444 14.4889 19.7333 14.6667 19.7333H17.3333Z"
            fill="white"
          />
          <g clip-path="url(#clip0)">
            <path
              d="M19.1667 10.2002H17.8333C17.7413 10.2002 17.6667 10.2748 17.6667 10.3669V11.7002C17.6667 11.7922 17.7413 11.8669 17.8333 11.8669H19.1667C19.2587 11.8669 19.3333 11.7922 19.3333 11.7002V10.3669C19.3333 10.2748 19.2587 10.2002 19.1667 10.2002Z"
              fill="white"
            />
            <path
              d="M17.5 8.8667H16.5C16.408 8.8667 16.3333 8.94132 16.3333 9.03337V10.0334C16.3333 10.1254 16.408 10.2 16.5 10.2H17.5C17.592 10.2 17.6667 10.1254 17.6667 10.0334V9.03337C17.6667 8.94132 17.592 8.8667 17.5 8.8667Z"
              fill="white"
            />
            <path
              d="M20.5 11.8667H19.5C19.408 11.8667 19.3333 11.9413 19.3333 12.0334V13.0334C19.3333 13.1254 19.408 13.2 19.5 13.2H20.5C20.592 13.2 20.6667 13.1254 20.6667 13.0334V12.0334C20.6667 11.9413 20.592 11.8667 20.5 11.8667Z"
              fill="white"
            />
            <path
              d="M20.5 8.8667H19.8333C19.7413 8.8667 19.6667 8.94132 19.6667 9.03337V9.70003C19.6667 9.79208 19.7413 9.8667 19.8333 9.8667H20.5C20.592 9.8667 20.6667 9.79208 20.6667 9.70003V9.03337C20.6667 8.94132 20.592 8.8667 20.5 8.8667Z"
              fill="white"
            />
            <path
              d="M17.1667 12.2002H16.5C16.408 12.2002 16.3333 12.2748 16.3333 12.3669V13.0335C16.3333 13.1256 16.408 13.2002 16.5 13.2002H17.1667C17.2587 13.2002 17.3333 13.1256 17.3333 13.0335V12.3669C17.3333 12.2748 17.2587 12.2002 17.1667 12.2002Z"
              fill="white"
            />
            <path
              d="M20 3.8667H17C16.8232 3.8667 16.6536 3.93694 16.5286 4.06196C16.4036 4.18699 16.3333 4.35655 16.3333 4.53337V7.53337C16.3333 7.71018 16.4036 7.87975 16.5286 8.00477C16.6536 8.12979 16.8232 8.20003 17 8.20003H20C20.1768 8.20003 20.3464 8.12979 20.4714 8.00477C20.5964 7.87975 20.6667 7.71018 20.6667 7.53337V4.53337C20.6667 4.35655 20.5964 4.18699 20.4714 4.06196C20.3464 3.93694 20.1768 3.8667 20 3.8667ZM19.3333 6.70003C19.3333 6.74424 19.3158 6.78663 19.2845 6.81788C19.2533 6.84914 19.2109 6.8667 19.1667 6.8667H17.8333C17.7891 6.8667 17.7467 6.84914 17.7155 6.81788C17.6842 6.78663 17.6667 6.74424 17.6667 6.70003V5.3667C17.6667 5.3225 17.6842 5.2801 17.7155 5.24885C17.7467 5.21759 17.7891 5.20003 17.8333 5.20003H19.1667C19.2109 5.20003 19.2533 5.21759 19.2845 5.24885C19.3158 5.2801 19.3333 5.3225 19.3333 5.3667V6.70003Z"
              fill="white"
            />
            <path
              d="M15 3.8667H12C11.8232 3.8667 11.6536 3.93694 11.5286 4.06196C11.4036 4.18699 11.3333 4.35655 11.3333 4.53337V7.53337C11.3333 7.71018 11.4036 7.87975 11.5286 8.00477C11.6536 8.12979 11.8232 8.20003 12 8.20003H15C15.1768 8.20003 15.3464 8.12979 15.4714 8.00477C15.5964 7.87975 15.6667 7.71018 15.6667 7.53337V4.53337C15.6667 4.35655 15.5964 4.18699 15.4714 4.06196C15.3464 3.93694 15.1768 3.8667 15 3.8667ZM14.3333 6.70003C14.3333 6.74424 14.3158 6.78663 14.2845 6.81788C14.2533 6.84914 14.2109 6.8667 14.1667 6.8667H12.8333C12.7891 6.8667 12.7467 6.84914 12.7155 6.81788C12.6842 6.78663 12.6667 6.74424 12.6667 6.70003V5.3667C12.6667 5.3225 12.6842 5.2801 12.7155 5.24885C12.7467 5.21759 12.7891 5.20003 12.8333 5.20003H14.1667C14.2109 5.20003 14.2533 5.21759 14.2845 5.24885C14.3158 5.2801 14.3333 5.3225 14.3333 5.3667V6.70003Z"
              fill="white"
            />
            <path
              d="M15 8.8667H12C11.8232 8.8667 11.6536 8.93694 11.5286 9.06196C11.4036 9.18699 11.3333 9.35655 11.3333 9.53337V12.5334C11.3333 12.7102 11.4036 12.8797 11.5286 13.0048C11.6536 13.1298 11.8232 13.2 12 13.2H15C15.1768 13.2 15.3464 13.1298 15.4714 13.0048C15.5964 12.8797 15.6667 12.7102 15.6667 12.5334V9.53337C15.6667 9.35655 15.5964 9.18699 15.4714 9.06196C15.3464 8.93694 15.1768 8.8667 15 8.8667ZM14.3333 11.7C14.3333 11.7442 14.3158 11.7866 14.2845 11.8179C14.2533 11.8491 14.2109 11.8667 14.1667 11.8667H12.8333C12.7891 11.8667 12.7467 11.8491 12.7155 11.8179C12.6842 11.7866 12.6667 11.7442 12.6667 11.7V10.3667C12.6667 10.3225 12.6842 10.2801 12.7155 10.2488C12.7467 10.2176 12.7891 10.2 12.8333 10.2H14.1667C14.2109 10.2 14.2533 10.2176 14.2845 10.2488C14.3158 10.2801 14.3333 10.3225 14.3333 10.3667V11.7Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                x="10.6667"
                y="3.2002"
                width="10.6667"
                height="10.6667"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import GuestbookBoxes from "../EditGuestbookPage/BoxesComponents/BoxesGrid";

import GuestbookNavigation from "./NavigationComponents/GuestbookNavigation";
import GuestbookHeader from "./HeaderComponents/GuestbookHeader";
import GuestbookFooter from "./FooterComponents/GuestbookFooter";

import LanguageBar from "@/components/GlobalComponents/LanguageBar.vue";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import { db } from "@/firebase";
import config from "../../config";

export default {
  components: {
    GuestbookNavigation,
    GuestbookHeader,
    GuestbookBoxes,
    GuestbookFooter,
    LanguageBar,
    ButtonGlobal,
    FetchingLoader,
  },
  data() {
    return {
      showNavigation: false,
      showHeader: false,
      showBoxes: false,
      showFooter: false,
      cookieExists: null,
      guestbookFetched: false,
      hover: false,
      toogleActive: this.browserCheck() !== "Safari",
      languageTypesIndex: 0,
      customFonts: {
        customFonts: false
      }
    };
  },
  firebase() {
    return {
      bodyBackgroundColor: {
        source: db.ref(`/hotels/${this.$customerId}/${this.$hotelId}/nav/`),
        asObject: true,
      },
      returnedData: {
        source: db.ref(`/hotels/${this.$customerId}/${this.$hotelId}/`),
        asObject: true,
        readyCallback: function (data) {
          this.guestbookFetched = true;
          this.showNavigation = true;
          this.showHeader = true;
          this.showBoxes = true;
          if (data.val().imageFooter) {
            this.showFooter = true;
          }
        },
      },
      pagesOverview: {
        source: db.ref(`pages/${this.$customerId}/${this.$hotelId}/overview`),
        asObject: true,
      },
    };
  }, //end of firebase
  created() {
    db.ref(`users/${this.$userId}/languageTypesIndex`).on("value", (data) => {
      this.languageTypesIndex = data.val();
    });
    db.ref(`customers/${this.$customerId}/fonts`)
      .once('value')
      .then( snapshot => {
        if(snapshot.exists()) {
          this.customFonts = snapshot.val();
        }
      });
  },
  methods: {
    openPreview: function (type) {
      if (this.toogleActive) {
        window.open(
          `${config.hardcodedPath}/preview/${this.$hotelId}/${type}`,
          "_blank"
        );
      } else {
        window.open(`${config.hardcodedPath}/mobile/${this.$hotelId}/${type}`, "_blank");
      }
    },
    toogleClicked() {
      if (this.browserCheck() !== "Safari") {
        this.toogleActive = this.toogleActive ? false : true;
      }
    },
    createArray(data) {
      var newArrayDataOfOjbect = Object.values(data);
      return newArrayDataOfOjbect;
    },
    addFooter: function () {
      this.showFooter = true;
      this.returnedData.imageFooter = [
        "https://images.unsplash.com/photo-1438522014717-d7ce32b9bab9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd",
      ];
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/imageFooter/`).set(
        this.returnedData.imageFooter
      );
    },
    browserCheck() {
      var N = navigator.appName,
        ua = navigator.userAgent,
        tem;
      var M = ua.match(
        /(opera|chrome|safari|firefox|msie|trident)\/?\s*(\.?\d+(\.\d+)*)/i
      );
      if (M && (tem = ua.match(/version\/([\d]+)/i)) != null) {
        M[2] = tem[1];
      }
      M = M ? M[1] : N;
      return M;
    },
  },
  computed: {
    changePreviewColorText() {
      //Gets chosen background color
      let hex = this.bodyBackgroundColor.guestbookBodyColor;
      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return String(h).charAt(0) == "#"
          ? String(h).substring(1, 7)
          : String(h);
      }
      // console.log("Color: "+hex);
      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#FFFFFF";
      }
    },
  },
};
</script>

<style scoped>
#background {
  top: 56px;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  line-height: 1.15;
}
.outerPreviewWrap {
  position: fixed;
  bottom: 16px; /* -24 from last item */
  right: 30px;
  z-index: 90;
}

.textWrap {
  margin: 4px 0 8px 0;
  font-weight: normal;
  font-size: 0.8em;
  display: inline-flex;
  align-items: center;
  text-align: center;
  color: #3f3d39;
  font-weight: 500;
  font-size: 16px;
}

.preview-menu__icon-precheckin {
  width: 34px;
  position: relative;
  left: -6px;
}

.preview-menu__icon-precheckin_desktop {
  width: 48px;
  position: relative;
  left: -3px;
}

.preview-menu__icon-checkin,
.preview-menu__icon-anonymous {
  width: 20px;
}

.preview-menu__icon-checkin_desktop,
.preview-menu__icon-anonymous_desktop {
  width: 40px;
}

.preview-menu__header {
  color: #3f3d39;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 5px;
}

.preview-menu__toogle {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.tooltip {
  display: flex;
  position: absolute;
  left: -280px;
  top: 32.5px;
  background-image: linear-gradient(
    to right,
    rgba(72, 185, 186, 1),
    rgba(137, 78, 153, 1)
  );
  padding: 10px;
  width: 250px;
  border-radius: 8px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  font-size: 12px;
}

.tooltip:hover {
  display: flex;
}

.item-icon {
  padding: 5px;
}

.flip {
  -moz-transform: scale(-1, -1);
  -o-transform: scale(-1, -1);
  -webkit-transform: scale(-1, -1);
  transform: scale(-1, -1);
}

.item-toogle {
  padding: 5px;
  height: 30px;
  width: 50px;
}

.phone {
  margin-left: 4px;
}

.PreCheckinWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  background: linear-gradient(180deg, #894e99 0%, #48b9ba 440%);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  color: #fff;
  transition: 0.5s all;
}
.PreCheckinWrap:hover {
  background-color: #49a39c;
}

.CheckinWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  background: linear-gradient(0deg, #48b9ba -169.17%, #894e99 270%);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  color: #fff;
  transition: 0.5s all;
}
.CheckinWrap:hover {
  background-color: #49a39c;
}

.GhostWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  background: linear-gradient(360deg, #48b9ba 0%, #894e99 442.5%);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  color: #fff;
  transition: 0.5s all;
}
.GhostWrap:hover {
  background-color: #49a39c;
}

.previewIcon {
  height: 32px;
  width: 32px;
  margin: auto;
}

@media (max-width: 1350px) {
  .outerPreviewWrap {
    bottom: 10px;
    right: 10px;
  }

  .textWrap {
    margin-bottom: 10px;
  }

  .preview-menu__header,
  .preview-menu__toogle {
    display: none;
  }
}
@media (max-width: 876px), (max-height: 400px) {
  .outerPreviewWrap {
    display: none;
  }
}
</style>
